import apiClient from './api/axiosConfig';

class AnnouncementService {
  // Get all announcements (authenticated)
  async getAnnouncements(params = {}) {
    try {
      const response = await apiClient.get('/announcements/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching announcements:', error);
      throw error;
    }
  }

  // Get active announcements (public)
  async getActiveAnnouncements(params = {}) {
    try {
      const response = await apiClient.get('/announcements/active/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching active announcements:', error);
      throw error;
    }
  }

  // Get homepage announcements (public)
  async getHomepageAnnouncements() {
    try {
      const response = await apiClient.get('/announcements/homepage/');
      return response.data;
    } catch (error) {
      console.error('Error fetching homepage announcements:', error);
      throw error;
    }
  }

  // Get header announcements (public)
  async getHeaderAnnouncements() {
    try {
      const response = await apiClient.get('/announcements/header/');
      return response.data;
    } catch (error) {
      console.error('Error fetching header announcements:', error);
      throw error;
    }
  }

  // Get popup announcements (authenticated)
  async getPopupAnnouncements() {
    try {
      const response = await apiClient.get('/announcements/popup/');
      return response.data;
    } catch (error) {
      console.error('Error fetching popup announcements:', error);
      throw error;
    }
  }

  // Get society-specific announcements
  async getSocietyAnnouncements(societyId, params = {}) {
    try {
      const response = await apiClient.get('/announcements/active/', {
        params: {
          ...params,
          society_id: societyId
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching society announcements:', error);
      throw error;
    }
  }

  // Get announcement by ID
  async getAnnouncement(id) {
    try {
      const response = await apiClient.get(`/announcements/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching announcement:', error);
      throw error;
    }
  }

  // Get announcement by slug
  async getAnnouncementBySlug(slug) {
    try {
      const response = await apiClient.get(`/announcements/slug/${slug}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching announcement by slug:', error);
      throw error;
    }
  }

  // Create announcement (authenticated)
  async createAnnouncement(data) {
    try {
      const response = await apiClient.post('/announcements/', data);
      return response.data;
    } catch (error) {
      console.error('Error creating announcement:', error);
      throw error;
    }
  }

  // Update announcement (authenticated)
  async updateAnnouncement(id, data) {
    try {
      const response = await apiClient.put(`/announcements/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating announcement:', error);
      throw error;
    }
  }

  // Partially update announcement (authenticated)
  async patchAnnouncement(id, data) {
    try {
      const response = await apiClient.patch(`/announcements/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error patching announcement:', error);
      throw error;
    }
  }

  // Delete announcement (authenticated)
  async deleteAnnouncement(id) {
    try {
      const response = await apiClient.delete(`/announcements/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting announcement:', error);
      throw error;
    }
  }

  // Track announcement view
  async trackView(announcementId) {
    try {
      const response = await apiClient.post(`/announcements/${announcementId}/view/`);
      return response.data;
    } catch (error) {
      console.error('Error tracking view:', error);
      throw error;
    }
  }

  // Track announcement click
  async trackClick(announcementId) {
    try {
      const response = await apiClient.post(`/announcements/${announcementId}/click/`);
      return response.data;
    } catch (error) {
      console.error('Error tracking click:', error);
      throw error;
    }
  }

  // Acknowledge announcement
  async acknowledge(announcementId) {
    try {
      const response = await apiClient.post(`/announcements/${announcementId}/acknowledge/`);
      return response.data;
    } catch (error) {
      console.error('Error acknowledging announcement:', error);
      throw error;
    }
  }

  // Get announcement statistics (admin only)
  async getStats() {
    try {
      const response = await apiClient.get('/announcements/stats/');
      return response.data;
    } catch (error) {
      console.error('Error fetching announcement stats:', error);
      throw error;
    }
  }

  // Get user's announcement views
  async getUserViews() {
    try {
      const response = await apiClient.get('/announcements/my-views/');
      return response.data;
    } catch (error) {
      console.error('Error fetching user views:', error);
      throw error;
    }
  }

  // Get user's announcement clicks
  async getUserClicks() {
    try {
      const response = await apiClient.get('/announcements/my-clicks/');
      return response.data;
    } catch (error) {
      console.error('Error fetching user clicks:', error);
      throw error;
    }
  }

  // Get user's announcement acknowledgments
  async getUserAcknowledgments() {
    try {
      const response = await apiClient.get('/announcements/my-acknowledgments/');
      return response.data;
    } catch (error) {
      console.error('Error fetching user acknowledgments:', error);
      throw error;
    }
  }
}

export const announcementService = new AnnouncementService();
